'use client';
import { useContext } from 'react';
import { AlertContext, FeatureFlagContext } from '../contexts';

export const useAlert = () => {
  const context = useContext(AlertContext);

  if (!context) {
    throw new Error('Alert context missing');
  }
  return context;
};

export const useFeatureFlagContext = () => {
  const context = useContext(FeatureFlagContext);

  if (!context) {
    throw new Error('Feature Flag context missing');
  }

  return context;
};
